import {memo} from 'react';

/**
 * A version of `React.memo` that accepts a generic type
 * and returns a memoized component of that type.
 */
export const typedMemo: <T>(c: T) => T = memo;

export function mergeRefs<T>(
  refs: (React.Ref<T> | undefined)[]
): React.RefCallback<T> {
  return value => {
    for (const ref of refs) {
      if (typeof ref === 'function') {
        ref(value);
        continue;
      }

      if (ref !== null && ref !== undefined) {
        (ref as React.MutableRefObject<T | null>).current = value;
      }
    }
  };
}
